// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__b5dc59268661f21ed085","cls2":"SimplePaperPodcast-cls2___1b3e31f24f16df780bb SimplePaperPodcast-cls1__b5dc59268661f21ed085"};